/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TripMetadata
 */
export interface TripMetadata {
    /**
     * 
     * @type {string}
     * @memberof TripMetadata
     */
    polyline: string;
}

export function TripMetadataFromJSON(json: any): TripMetadata {
    return TripMetadataFromJSONTyped(json, false);
}

export function TripMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'polyline': json['polyline'],
    };
}

export function TripMetadataToJSON(value?: TripMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'polyline': value.polyline,
    };
}


